import type { CastItem } from "@/types/film";

export const castList: CastItem[] = [
  {
    id: "c1",
    name: "林晚晴",
    character: "苏蜜",
    roleType: "主演",
    bio: "林晚晴，实力派演员，以细腻自然的表演风格著称。在多部现实题材作品中塑造了鲜明的女性形象，此次在影片中饰演果园的女儿苏蜜，从少女演到成熟，完成了一次跨度十余年的成长演绎。",
    works: ["夏日回声", "海岸线以北", "一封未寄出的信", "蜜桃成熟时3D"],
    image:
      "https://readdy.ai/api/search-image?query=professional%20cinematic%20portrait%20of%20an%20elegant%20young%20actress%20with%20soft%20warm%20studio%20lighting%20on%20a%20plain%20warm%20beige%20background%2C%20editorial%20headshot%2C%20gentle%20expression%2C%20high%20detail&width=800&height=1000&seq=peach-cast-01&orientation=portrait",
  },
  {
    id: "c2",
    name: "陈知遥",
    character: "江樾",
    roleType: "主演",
    bio: "陈知遥，影视与舞台双栖演员，擅长诠释内敛而深情的角色。此次饰演沉默寡言却心怀热爱的青年江樾，用大量克制的细节撑起了人物跨越多年的情感线索。",
    works: ["归途列车", "沉默的风", "蜜桃成熟时3D"],
    image:
      "https://readdy.ai/api/search-image?query=professional%20cinematic%20portrait%20of%20a%20calm%20young%20actor%20with%20soft%20warm%20studio%20lighting%20on%20a%20plain%20warm%20beige%20background%2C%20editorial%20headshot%2C%20thoughtful%20expression%2C%20high%20detail&width=800&height=1000&seq=peach-cast-02&orientation=portrait",
  },
  {
    id: "c3",
    name: "苏念",
    character: "林小满",
    roleType: "主演",
    bio: "苏念，新生代演员，气质清新，擅长诠释充满活力的少女形象。在影片中饰演苏蜜的好友林小满，是故事中难得的明亮色彩，也是推动苏蜜做出改变的重要力量。",
    works: ["十七岁的海", "蜜桃成熟时3D"],
    image:
      "https://readdy.ai/api/search-image?query=professional%20cinematic%20portrait%20of%20a%20cheerful%20young%20actress%20with%20soft%20warm%20studio%20lighting%20on%20a%20plain%20warm%20beige%20background%2C%20editorial%20headshot%2C%20bright%20expression%2C%20high%20detail&width=800&height=1000&seq=peach-cast-03&orientation=portrait",
  },
  {
    id: "c4",
    name: "周叙",
    character: "老陶",
    roleType: "配角",
    bio: "周叙，资深演员，从艺三十余年。此次饰演果园的老园丁老陶，是苏蜜的引路人，也是整片土地记忆的守护者。他用举重若轻的表演，为影片注入了沉静的力量。",
    works: ["长街", "老屋", "白露为霜", "蜜桃成熟时3D"],
    image:
      "https://readdy.ai/api/search-image?query=professional%20cinematic%20portrait%20of%20a%20wise%20older%20man%20with%20soft%20warm%20studio%20lighting%20on%20a%20plain%20warm%20beige%20background%2C%20editorial%20headshot%2C%20gentle%20expression%2C%20high%20detail&width=800&height=1000&seq=peach-cast-04&orientation=portrait",
  },
  {
    id: "c5",
    name: "顾青",
    character: "阿澈",
    roleType: "配角",
    bio: "顾青，多面手演员，在影片中饰演江樾在城市结识的好友阿澈。角色戏份不多，却屡屡在关键节点出现，成为连接城市与小镇两种生活的重要纽带。",
    works: ["四月的城市", "蜜桃成熟时3D"],
    image:
      "https://readdy.ai/api/search-image?query=professional%20cinematic%20portrait%20of%20a%20stylish%20young%20man%20with%20soft%20warm%20studio%20lighting%20on%20a%20plain%20warm%20beige%20background%2C%20editorial%20headshot%2C%20confident%20expression%2C%20high%20detail&width=800&height=1000&seq=peach-cast-05&orientation=portrait",
  },
  {
    id: "c6",
    name: "白露",
    character: "苏母",
    roleType: "配角",
    bio: "白露，著名舞台剧演员。此次饰演苏蜜的母亲，一位默默支撑果园多年的女性。她用极少的台词，演出了人物一生的坚韧与柔软。",
    works: ["春分", "母亲的信", "蜜桃成熟时3D"],
    image:
      "https://readdy.ai/api/search-image?query=professional%20cinematic%20portrait%20of%20a%20warm%20elegant%20older%20woman%20with%20soft%20studio%20lighting%20on%20a%20plain%20warm%20beige%20background%2C%20editorial%20headshot%2C%20kind%20expression%2C%20high%20detail&width=800&height=1000&seq=peach-cast-06&orientation=portrait",
  },
  {
    id: "c7",
    name: "何竞",
    character: "陈医生",
    roleType: "配角",
    bio: "何竞，青年演员，饰演小镇上唯一的一名医生陈医生。角色始终以旁观者的身份注视着故事的发展，是影片中理性与温情并存的存在。",
    works: ["乡镇纪事", "蜜桃成熟时3D"],
    image:
      "https://readdy.ai/api/search-image?query=professional%20cinematic%20portrait%20of%20a%20serious%20young%20man%20with%20soft%20warm%20studio%20lighting%20on%20a%20plain%20warm%20beige%20background%2C%20editorial%20headshot%2C%20calm%20expression%2C%20high%20detail&width=800&height=1000&seq=peach-cast-07&orientation=portrait",
  },
  {
    id: "c8",
    name: "秦朗",
    character: "少年阿樾",
    roleType: "配角",
    bio: "秦朗，备受关注的新人演员，饰演少年时期的江樾。他以干净自然的表演，呈现了人物最初的模样，也承接了整段回忆的起点。",
    works: ["蜜桃成熟时3D"],
    image:
      "https://readdy.ai/api/search-image?query=professional%20cinematic%20portrait%20of%20a%20boyish%20young%20actor%20with%20soft%20warm%20studio%20lighting%20on%20a%20plain%20warm%20beige%20background%2C%20editorial%20headshot%2C%20innocent%20expression%2C%20high%20detail&width=800&height=1000&seq=peach-cast-08&orientation=portrait",
  },
];